module.exports = __webpack_public_path__ + "static/Start-9807b9a89a025234d82370bb59e9ce90.svg";